import * as Yup from "yup"

const mobileSchema = Yup.object().shape({
  first_name: Yup.string().max(20, "Too Long!").required("Required"),
  last_name: Yup.string().max(20, "Too Long!").required("Required"),
  company: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
})

export default mobileSchema
